let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("41u9s")).then(() => parcelRequire('a7eIW'));